import React, { useContext, useState } from 'react'

import { useSelector } from 'react-redux'

import TitledSelector from './TitledSelector'
import { QuotasContext } from '../../../../Providers/Quotas/QuotasProvider'
import SearchCheckbox from '../../../antd/Selects/SearchCheckbox'
import Loading from '../../../shared/Loading'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'

const TITLED_SELECTOR_STYLE = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  justifyContent: 'center',
  paddingLeft: '5px',
  paddingRight: '5px',
  marginBottom: '10px'
}

const Settings = ({ onSchoolsChanged, onSectionsChange, onSelectSector }) => {
  const { globalLoading, loading, sections, sectors, schools } = useContext(QuotasContext)

  const t = useSelector(selectTranslate)

  const [selectedSector, setSelectedSector] = useState(null)
  const [selectedSections, setSelectedSections] = useState([])
  const [selectedSchools, setSelectedSchools] = useState([])

  const handleSectorSelect = newSector => {
    setSelectedSector(newSector)
    onSelectSector(newSector)
  }

  const handleSectionCheck = (section, add) => {
    const newSections = add
      ? [...selectedSections, section]
      : selectedSections.filter(ss => ss.id !== section.id)

    setSelectedSections(newSections)
    onSectionsChange(newSections.sort((a, b) => a.abbreviation.localeCompare(b.abbreviation)))
  }

  const handleSchoolCheck = (school, add) => {
    const newSchools = add
      ? [...selectedSchools, school]
      : selectedSchools.filter(ss => ss.id !== school.id)

    setSelectedSchools(newSchools)
    onSchoolsChanged(newSchools)
  }

  return (
    <div style={{
      width: '300px',
      height: '100%',
      padding: '4px',
      overflowY: 'auto'
    }}
    >
      {!loading && !globalLoading && (
        <>
          <TitledSelector
            style={TITLED_SELECTOR_STYLE}
            data={sectors}
            dataKey='name'
            title={t('Care unit')}
            placeholder={t('Choose a care unit')}
            onDataSelected={handleSectorSelect}
          />
          {selectedSector && (
            <div style={{ width: 'calc(100% - 10px)', height: '44%' }}>
              <SearchCheckbox
                style={{ height: '100%' }}
                checkAllOption
                items={sections}
                labelKey='abbreviation'
                tooltipKey='name'
                title={t('Sections')}
                valueKey='id'
                onCheck={handleSectionCheck}
                onCheckAll={sections => {
                  setSelectedSections(sections)
                  onSectionsChange(sections)
                }}
              />
            </div>
          )}
          {selectedSector && (
            <div style={{ width: 'calc(100% - 10px)', height: '44%' }}>
              <SearchCheckbox
                style={{ height: '100%' }}
                checkAllOption
                initCheckAll
                items={schools}
                labelKey='name'
                title={t('Schools')}
                valueKey='id'
                dataKey='name'
                onCheck={handleSchoolCheck}
                onCheckAll={schools => {
                  setSelectedSchools(schools)
                  onSchoolsChanged(schools)
                }}
              />
            </div>
          )}
        </>
      )}
      {(loading || globalLoading) && <Loading size='1x' />}
    </div>
  )
}

export default Settings
